import axios, { AxiosInstance } from "axios";

export const API_URL = process.env.REACT_APP_API_URL || "";

/**
 * Builds an axios instance pointed at the API with the organizer's Auth0
 * bearer token attached. Pass the token from `getAccessTokenSilently()`.
 */
export function createApiClient(token: string): AxiosInstance {
  return axios.create({
    baseURL: API_URL,
    headers: { Authorization: `Bearer ${token}` },
  });
}

/** Public client (no auth) — used for the health check. */
export function createPublicClient(): AxiosInstance {
  return axios.create({ baseURL: API_URL });
}

/** Magic-link client — authenticates a session participant via their token. */
export function createSessionClient(sessionToken: string): AxiosInstance {
  return axios.create({
    baseURL: API_URL,
    headers: { "X-Session-Token": sessionToken },
  });
}
